import React, {useState} from "react";
import {Dialog} from "primereact/dialog";
import {XButton} from "@michalrakus/x-react-web-lib/XButton";
import {xLocaleOption} from "@michalrakus/x-react-web-lib/XLocale";
import {FindParam, ResultType, XCustomFilter} from "@michalrakus/x-react-web-lib/FindParam";
import {Dropdown, DropdownChangeEvent} from "primereact/dropdown";
import {OperationType, XUtils} from "@michalrakus/x-react-web-lib/XUtils";
import {XAutoCompleteBase} from "@michalrakus/x-react-web-lib/XAutoCompleteBase";
import {Utils} from "../../Utils";
import {XtDocTemplate} from "@michalrakus/x-react-web-lib/xt-doc-template";
import {XtDocTemplateBrowse} from "../doc-templates/XtDocTemplateBrowse";
import {EnumEnum, TypPristupuSluzba, XtTemplateType} from "../../common/enums";
import {InputText} from "primereact/inputtext";
import {dateAsUI, dateFromModel, datetimeFormat, numberAsUI} from "@michalrakus/x-react-web-lib/XUtilsConversions";
import {FindResult} from "@michalrakus/x-react-web-lib/lib/serverApi/FindResult";
import {TlacitDokumentRequest} from "../../common/klient-api";
import {XCalendar} from "@michalrakus/x-react-web-lib/XCalendar";
import {XUtilsCommon} from "@michalrakus/x-react-web-lib/XUtilsCommon";
import {XDropdownForEntity} from "@michalrakus/x-react-web-lib/XDropdownForEntity";
import {XEnum} from "../../model/user/x-enum.entity";
import * as _ from "lodash";
import {KlientSluzba} from "../../model/klient/klient-sluzba.entity";

// dialog being opened by running app function for row
// maybe will be moved to lib in the future

export enum RunningMode {
    singleOnly = "singleOnly",
    selected = "selected",
    filtered = "filtered"
}

export interface TlacitDokumentDialogState {
    opened: boolean;
    selectedRow?: any, // used when mode selected is selected (momentalne KlientSluzba)
    findParam?: FindParam, // used when mode filtered is selected
    onHideDialog?: () => void;
}

// vseobecny nazov (bol) RunAppButtonForRowDialog (ak raz bude vseobecny dialog s panelom parametrov)
export const TlacitDokumentDialog = (props: {
    dialogState: TlacitDokumentDialogState;
}) => {

    const [runningMode, setRunningMode] = useState<RunningMode>(RunningMode.selected);
    const [rowCount, setRowCount] = useState<number | null>(null);
    // specific field
    const [vincentPoradProjekt, setVincentPoradProjekt] = useState<XEnum | null>(null);
    const [docTemplate, setDocTemplate] = useState<XtDocTemplate | null>(null);
    // specific content
    const [datumDokumentu, setDatumDokumentu] = useState<Date | null>(XUtilsCommon.today());

    let docTemplateError: string | undefined = undefined;

    const onChangeRunningMode = (e: DropdownChangeEvent) => {
        const runningModeLocal: RunningMode = e.value;
        setRunningMode(runningModeLocal);

        computeRowCount(runningModeLocal, vincentPoradProjekt);
    }

    const onChangeVincentPoradProjekt = (value: XEnum | null) => {
        setVincentPoradProjekt(value);
        setDocTemplate(null); // zrusime aktualny template, user musi vybrat iny (pre iny projekt)
        computeRowCount(runningMode, value); // zmenil sa filter
    }

    const computeRowCount = async (runningMode: RunningMode, vincentPoradProjekt: XEnum | null) => {
        let rowCount: number | null = null;
        if (runningMode === RunningMode.selected) {
            if (props.dialogState.selectedRow) {
                rowCount = 1;
            }
            else {
                rowCount = 0;
            }
        }
        else if (runningMode === RunningMode.filtered) {
            const findParam: FindParam = addVincentPoradProjektFilter(props.dialogState.findParam!, vincentPoradProjekt);
            // TODO - daj do Utils (aj v lib-ke je takyto kod)
            const findResult: FindResult = await XUtils.fetchOne('lazyDataTableFindRows', findParam);
            findResult.totalRecords = parseInt(findResult.totalRecords as any as string);
            rowCount = findResult.totalRecords;
        }
        setRowCount(rowCount);
    }

    const addVincentPoradProjektFilter = (findParam: FindParam, vincentPoradProjekt: XEnum | null): FindParam => {
        if (Utils.isSluzbaVincentPoradenstvo()) {
            findParam = _.cloneDeep(findParam);
            findParam.customFilterItems = XUtilsCommon.filterAnd(findParam.customFilterItems, {where: `[vincentPoradProjekt] = :vincentPoradProjektId`, params: {vincentPoradProjektId: vincentPoradProjekt?.id ?? 0}});
        }
        return findParam;
    }

    const onShow = async () => {
        // sem daj inicializaciu (reset) hodnot inputov dialogu

        computeRowCount(runningMode, vincentPoradProjekt);
    }

    const onOk = async () => {

        // validation

        if (Utils.isSluzbaVincentPoradenstvo()) {
            if (!vincentPoradProjekt) {
                alert(`Položka "Projekt" musí byť vyplnená.`);
                return;
            }
        }

        if (rowCount === 0) {
            alert("Počet záznamov je 0.");
            return;
        }

        if (!docTemplate) {
            alert(`Položka "Dokument" musí byť vyplnená.`);
            return;
        }

        if (docTemplateError) {
            alert(docTemplateError);
            return;
        }

        if (!datumDokumentu) {
            alert(`Položka "Dátum dokumentu" musí byť vyplnená.`);
            return;
        }

        // upozornenie
        if (rowCount && rowCount > 100) {
            if (!window.confirm(`Chcete naozaj vytlačiť dokumenty pre ${rowCount} záznamov?`)) {
                return;
            }
        }

        if (runningMode === RunningMode.selected) {
            if (props.dialogState.selectedRow) {
                const today: Date = new Date();
                const cisloZmluvyMMddHHmmss: number = parseInt(datetimeFormat(today, 'MMddHHmmss'));
                const cisloZmluvyYYYY: string = datetimeFormat(today, 'yyyy');
                await tlacitDokument(docTemplate, props.dialogState.selectedRow, datumDokumentu, cisloZmluvyMMddHHmmss, cisloZmluvyYYYY);
            }
        }
        else if (runningMode === RunningMode.filtered) {
            const today: Date = new Date();
            let cisloZmluvyMMddHHmmss: number = parseInt(datetimeFormat(today, 'MMddHHmmss'));
            const cisloZmluvyYYYY: string = datetimeFormat(today, 'yyyy');
            // musime zmenit result type
            // pre istotu vyklonujeme (aj tak asi uz nepouzijeme props.dialogState.findParam, ak zbehne export/tlac)
            let findParamAllRows: FindParam = {...props.dialogState.findParam!};
            findParamAllRows.resultType = ResultType.AllRows;
            findParamAllRows = addVincentPoradProjektFilter(findParamAllRows, vincentPoradProjekt);
            const findResult: FindResult = await XUtils.fetchOne('lazyDataTableFindRows', findParamAllRows);
            for (const row of findResult.rowList!) {
                await tlacitDokument(docTemplate, row, datumDokumentu, cisloZmluvyMMddHHmmss, cisloZmluvyYYYY);

                // inkrementujeme aby sme mali unique, aj tak, ak budu tlacit v davkach rychlo po sebe (nestihne uplynut dostatocny pocet sekund), tak nebude unique
                // aj tak to nikto nebude riesit
                cisloZmluvyMMddHHmmss++;
            }
        }

        props.dialogState.onHideDialog!();
    }

    const tlacitDokument = async (docTemplate: XtDocTemplate, klientSluzba: KlientSluzba, datumDokumentu: Date, cisloZmluvyMMddHHmmss: number, cisloZmluvyYYYY: string) => {
        const cisloZmluvyMMddHHmmssPadded: string = cisloZmluvyMMddHHmmss.toString().padStart("MMddHHmmss".length, '0');
        const cisloZmluvy: string = `${cisloZmluvyMMddHHmmssPadded}/${cisloZmluvyYYYY}`;
        const tlacitDokumentRequest: TlacitDokumentRequest = {docTemplateRowId: docTemplate.id, klientSluzbaId: klientSluzba.id, datumDokumentu: datumDokumentu, cisloZmluvy: cisloZmluvy};
        await Utils.klientSluzbaTlacitDokument(docTemplate, tlacitDokumentRequest, cisloZmluvy, klientSluzba);
    }

    let rowCountText: string = numberAsUI(rowCount, 0);
    if (runningMode === RunningMode.selected && props.dialogState.selectedRow) {
        rowCountText += " - " + Utils.klientCreateIDInfo(props.dialogState.selectedRow.klient);
    }

    let docTemplateFilter: XCustomFilter = Utils.docTemplateFilter("KlientSluzba");  // zatial natvrdo
    if (Utils.isSluzbaVincentPoradenstvo()) {
        docTemplateFilter = XUtilsCommon.filterAnd(docTemplateFilter, {where: `[vincentPoradProjekt] = :vincentPoradProjektId`, params: {vincentPoradProjektId: vincentPoradProjekt?.id ?? 0}})!;
    }

    // poznamka: renderovanie vnutornych komponentov Dialogu sa zavola az po otvoreni dialogu
    const labelWidth: string = '11rem';
    return (
        <Dialog visible={props.dialogState.opened} onShow={onShow} onHide={props.dialogState.onHideDialog!}>
            <div key="expExportType" className="field grid">
                <label className="col-fixed" style={{width: labelWidth}}>Mód</label>
                <Dropdown value={runningMode} options={[{value: RunningMode.selected, label: "vyselektovaný záznam"}, {value: RunningMode.filtered, label: "vyfiltrované záznamy"}]} onChange={onChangeRunningMode}/>
            </div>
            <div key="expRowCount" className="field grid">
                <label className="col-fixed" style={{width: labelWidth}}>Počet záznamov</label>
                <InputText value={rowCountText} readOnly={true} style={{width: '20rem'}}/>
            </div>
            {Utils.isSluzbaVincentPoradenstvo() ?
                <div key="vincentPoradProjekt" className="field grid">
                    <label className="col-fixed" style={{width: labelWidth}}>Projekt *</label>
                    <XDropdownForEntity entity="XEnum" displayField="name" filter={Utils.enumFilter(EnumEnum.vincentPoradProjekt)} sortField="enumOrder" isNotNull={true}
                                        value={vincentPoradProjekt} onChange={onChangeVincentPoradProjekt}/>
                </div> : null}
            <div className="field grid">
                <label className="col-fixed" style={{width: labelWidth}}>Dokument *</label>
                <XAutoCompleteBase value={docTemplate} onChange={(docTemplate: XtDocTemplate | null, objectChange: OperationType) => setDocTemplate(docTemplate)}
                                   onErrorChange={(error: string | undefined) => docTemplateError = error} idField="id"
                                   field={["label"]}
                                   suggestionsQuery={{entity: "XtDocTemplate", fields: ["templateXFile.name"], filter: docTemplateFilter}}
                                   searchBrowse={<XtDocTemplateBrowse/>} width={`calc(100% - ${labelWidth})`}/>
            </div>
            {/* specific content */}
            <div className="field grid">
                <label className="col-fixed" style={{width: labelWidth}}>Dátum dokumentu *</label>
                <XCalendar value={datumDokumentu} onChange={(value: Date | null) => setDatumDokumentu(value)}/>
            </div>
            <div className="flex justify-content-center">
                <XButton label={xLocaleOption('ok')} onClick={onOk}/>
                <XButton label={xLocaleOption('cancel')} onClick={props.dialogState.onHideDialog!}/>
            </div>
        </Dialog>
    );
}
